export default __webpack_public_path__ + "static/media/Upwork.9513616c.png";